import { Typography, TypographyProps } from '@mui/material';
import {
  MoneyType,
  formatRate,
  formatServerMoney,
  mapClientMoneyToServerMoney,
} from '@razz-team/utils';

export interface MoneyRateProps extends Omit<TypographyProps, 'children'> {
  currency: string;
  rate: MoneyType;
}

export function MoneyRate({ currency, rate, ...props }: MoneyRateProps) {
  const left = formatServerMoney(mapClientMoneyToServerMoney({ amount: '1', currency }));
  const right = formatRate(rate);

  return <Typography {...props}>{`${left} = ${right}`}</Typography>;
}
